import React from 'react'

const SectionBtn = ({ text, link }) => {
    return (
        <a href={link}>{text}</a>
    )
}

export default SectionBtn